import "./input.scss";

function Input({
  onChange,
  plac,
  label,
  Class = "",
  value = "",
  type = "text",
  disabled = false,
  maxLength,
}) {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <fieldset
      className={`input-card input-card-${Class}${value !== "" ? " input-card-filled" : ""}${plac ? " input-card-has-placeholder" : ""}${disabled ? " input-card-disabled" : ""}`}
      dir="rtl"
    >
      <legend className={`input-label input-label-${Class}`}>
        {label}
      </legend>

      <input
        className={`input input-${Class}`}
        type={type}
        placeholder={plac}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        maxLength={maxLength}
        aria-label={label}
      />
    </fieldset>
  );
}

export default Input;
